import { z } from 'zod';
import { expectType, zDocument } from './model.js';
import { EmptyPollOption, zPollOption } from './poll.js';
export const zPollResponse = zDocument.extend({
    type: z.literal('pollResponse'),
    poll: z.string(),
    option: zPollOption,
    user: z.string()
});
expectType({});
expectType({});
export const EmptyPollResponse = {
    type: 'pollResponse',
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    poll: '',
    user: '',
    option: EmptyPollOption
};
